import { EOfferType, EDealType, TWantType } from 'shared/types/wantType';

export const WANT_KNOW_TYPE: TWantType[] = [
  {
    id: EDealType.Sale,
    text: 'Продажу',
    imgClass: 'coin',
  },
  {
    id: EDealType.Rent,
    text: 'Аренду',
    imgClass: 'key',
  },
  {
    id: EDealType.Host,
    text: 'Посуточно',
    imgClass: 'calendar',
  },
];

export const HOUSE_APARTMENT_TYPE = [
  {
    id: EOfferType.Apartment,
    text: 'Квартиры',
    imgClass: 'apartment',
  },
  {
    id: EOfferType.Suburban,
    text: 'Дома',
    imgClass: 'house',
  },
];
